import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { createStore } from "./storeHelper";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:ImagesStore`);

export const useImagesStore = defineStore(
  "images",
  createStore({
    state: {
      objectUrls: {},
    },

    getters: {
      imageUrlByName: (state) => (name) => state.objectUrls[name],
    },

    actions: {
      uploadedImageFileName(uploadResult) {
        if (typeof uploadResult === "string") {
          return uploadResult;
        }

        // Backend may return either a plain file name or a wrapper object with blob metadata.
        const imageFileName =
          uploadResult?.imageFileName ||
          uploadResult?.fileName ||
          uploadResult?.name ||
          uploadResult?.blob?.name;

        return typeof imageFileName === "string" ? imageFileName : null;
      },

      addBlob(filename, blob) {
        this.objectUrls[filename] = blob;
      },

      async loadImage(filename) {
        debug("loadImage", filename);
        if (!filename) {
          return null;
        }

        if (this.objectUrls[filename]) {
          return this.objectUrls[filename];
        }

        const objectUrl = await ApiClient.getFile(`/images/${filename}`);
        this.addBlob(filename, objectUrl);
        return objectUrl;
      },

      async sendImage(file) {
        debug("sendImage", file.name);
        const formData = new FormData();
        formData.append("file", file);

        const result = await ApiClient.post("/images", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        debug("sendImage result", result);
        const fileName = this.uploadedImageFileName(result);

        if (!fileName) {
          throw new Error("Image upload response did not include a file name");
        }

        return fileName;
      },
    },
  }),
);
